/*jshint esversion: 6 */

import get from 'lodash/get';

/**
 * Get the start timestamp (in ms)
 * @param store
 * @returns {*}
 */
export function getQuizStartTime(store) {
    return store.timeStart;
}

/**
 * Get the time limit (in ms) for the current quiz
 * @param store
 * @returns {number}
 */
export function getTimelimitInMs(store) {
    return getTimelimit(store) * 60 * 1000;
}

/**
 * Get the time limit (in minutes) for the current quiz
 * @param store
 * @returns {*}
 */
export function getTimelimit(store) {
    return store.post.additional_meta.timeLimit;
}

/**
 * Get the remaining time for the current quiz
 * @param store
 * @returns {number}
 */
export function getRemainingTime(store) {
    return Math.max( getTimelimitInMs(store) - (Date.now() - getQuizStartTime(store)), 0);
}

export function getFinishingTime(userStore, quizStore) {

    let startTime = parseInt( get(userStore, quizId(quizStore) + '.startDate', 0), 10);
    let endTime = parseInt( get(userStore, quizId(quizStore) + '.endDate', 0), 10);

    return endTime - startTime;
}

/**
 * Get tags for current question
 * @param question
 * @returns {array};
 */
export function getTagsForQuestion(question) {
    return question['question-meta'].tags;
}

/**
 * Get the points for a specific tag
 * @param store
 * @param tag
 * @returns {number}
 */
export const getPointsForTag = (store, tag) => {
    return get(store, 'tags.' + tag , 0);
}

export const getMaxPoints = (userStore, quizStore) => {

    return get(userStore, 'quizzes.' + quizId(quizStore), 0);

}

export const getMaxPointsForQuiz = (generalStore, quizStore) => {
    return get(generalStore, 'quizzes.' + quizId(quizStore) + '.maxPoints', -10);
}

/**
 * Returns the user points from {quiz}
 */
export const getUserPointsForQuiz = (result, quiz) => {
    return get(result,  quizId(quiz) + '.points', 0);
}

/**
 * Returns the current overall top score (for all quizzes)
 */
export const getCurrentMaxScore = (general) => {
    return get(general, 'topScore', 0);
}

/* Get the best finishing time for the current quiz. Need an unrealistic start value to be able to start comparing */
export const getBestFinishingTime = (generalStore, quizStore) => {
    return get(generalStore, `quizzes.${quizId(quizStore)}.bestFinishingTime`, 999999);
}

export const getCollectedPoints = (generalStore, quizStore) => {
    return get(generalStore, `collectedPoints`, 0);
}

export const getGeneralProp = (prop, generalStore, quizStore) => {
    return get(generalStore, `quizzes.${quizId(quizStore)}.${prop}`, 0);
}

export const getPointsForCurrentQuiz = (result, quiz) => {
    return get(result, `${quizId(quiz)}.points`, 0);
}

/* Get the current quiz id */
export const quizId = (quiz) => {
    return quiz.post.id;
}

/* Get the result for the current loaded quiz or null */
export const currentResult = (quiz, result) => {
    return get(result, quizId(quiz), null);
}

/* Return badges recieved after the last quiz */
export const getNewBadges = (quiz, result) => {
    return get(result, `new_badges`, {});
}

export const availablePointsForQuiz = (quiz) => {
    return get(quiz, `post.additional_meta.questions`, []).length;
}

/**
 * Get the title of the {quiz}
 * @param {quiz}
 * @returns {string}
 */
export const quizTitle = quiz => {
    return get(quiz, 'post.title.rendered', '');
}

/**
 * Returns the featured image for the quiz
 * @param {quiz} The quiz store
 * @returns {string}
 */
export const featuredImage = (quiz) => {
    return get(quiz, 'post.additional_meta.featuredImage', '');
}



/**
 * Return the latest question or undefined
 * @param {props} The props
 * @returns {object} or {undefined}
 */
export const question = props => {
    let questions = get(props, 'quiz.questions');
    return questions && questions.length ? questions[questions.length - 1] : undefined;
};

/**
 * Get the current index
 * @param {quiz} The quiz store
 * @returns {integer}
 */
export const questionIndex = quiz => {
    return get(quiz, 'questions.length', 0);
}


